import { useRef } from 'react';
import { Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PrestationsEditor from '../../../AdmissionPage/components/PatientServicesPE/PrestationsEditor';

const PrestationsSummaryModal = ({
  visible,
  onClose,
  prestations,
  evaluationType,
  companyId,
  outsourcingId,
  thirdPartyId,
  branchOfficeId,
  patientData,
  onPrestationsChange,
}) => {
  const prestationsRef = useRef(prestations || []);

  const handlePrestationsChange = (updated) => {
    prestationsRef.current = updated;
  };

  const handleClose = () => {
    if (onPrestationsChange) {
      onPrestationsChange(prestationsRef.current);
    }
    onClose();
  };

  return (
    <Modal
      open={visible}
      onCancel={handleClose}
      footer={null}
      closable={false}
      width={1100}
      destroyOnClose
      className="prestations-summary-modal"
    >
      <div className="prestations-summary-modal__header">
        <h1 className="prestations-summary-modal__title">Detalle de protocolos</h1>
        <CloseOutlined
          className="prestations-summary-modal__close"
          onClick={handleClose}
        />
      </div>

      <PrestationsEditor
        initialPrestations={prestations}
        evaluationType={evaluationType}
        companyId={companyId}
        outsourcingId={outsourcingId}
        thirdPartyId={thirdPartyId}
        branchOfficeId={branchOfficeId}
        patientData={patientData}
        addAttachedServices
        onPrestationsChange={handlePrestationsChange}
      />
    </Modal>
  );
};

export default PrestationsSummaryModal;
